<template>
  <content-block title="报价明细">
    <TableWithPagination
      :tableData="list" row-key="index"
      :editConfig="{ trigger: 'munal', mode: 'cell' }"
      :columnList="columnList"
      :showFooter="isShowFooter"
      :footerData="footerData"
      size="mini" />
  </content-block>
</template>
<script>
import { dateFormat } from '@/utils/dateFormat';
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
export default {
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      list: [],
    };
  },
  computed: {
    columnList () {
      return [
        {
          tooltip: true,
          label: '备件编码',
          prop: 'code',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '含税单价（元）',
          prop: 'price',
          minWidth: '140px',
          editRender: {
            name: 'input',
            attrs: { type: 'text', placeholder: '请输入含税单价' },
          },
          render: (h, { row }) => {
            let result = [];
            if (this.edit) {
              result.push(
                <el-input-number v-model={row.price} min={0} precision={2} controls={false} placeholder='请输入含税单价' onChange={val => this.handleRowChange(val, row)}></el-input-number>,
              );
            } else {
              result.push(row.price);
            }
            return h('div', result);
          },
        },
        {
          tooltip: true,
          label: '数量',
          minWidth: '140px',
          prop: 'quantity',
        },
        {
          tooltip: true,
          label: '单位',
          prop: 'unitName',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '兼容性',
          prop: 'compatibilityRequirementDesc',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '质保期',
          prop: 'qualityAssPeriod',
          minWidth: '140px',
          render: (h, { row }) => {
            return h('div', [`${row.qualityAssPeriod && row.qualityAssPeriodUnitName ? row.qualityAssPeriod + row.qualityAssPeriodUnitName : ''}`]);
          },
        },
        {
          tooltip: true,
          label: '含税金额（元）',
          prop: 'rowAmount',
          minWidth: '140px',
          render: (h, { row }) => {
            row.rowAmount = row.price * row.quantity;
            return h('div', [`${row.rowAmount}`]);
          },
        },
        {
          tooltip: true,
          label: '税率',
          prop: 'taxRate',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '计划交付时间',
          prop: 'plannedDeliveryDate',
          minWidth: '140px',
          format: (val) => {
            return val ? dateFormat(val).format('YYYY-MM-DD HH:mm:ss') : '--';
          },
        },
      ];
    },
    isShowFooter () {
      if (this.list?.length) {
        return true;
      }
      return false;
    },
    footerData () {
      if (this.list.length) {
        let total = 0;
        for (let i = 0; i < this.list.length; i++) {
          const info = this.list[i];
          total += +info.rowAmount;
        }
        return [
          {
            checkTitle: '合计',
            rowAmount: total,
          },
        ];
      }
      return [];
    },
  },
  watch: {
    info: {
      deep: true,
      immediate: true,
      handler (val) {
        this.list = [];
        (val.itemList || []).map(item => {
          this.list.push({
            plannedDeliveryDate: val.plannedDeliveryDate,
            ...item,
          });
        });
      },
    },
  },
  methods: {
    handleRowChange (val, row) {
      const infos = this.info;
      infos.itemList.map(item => {
        if (item.id === row.id) {
          item.price = row.price;
        }
        return item;
      });
      this.$emit('update:info', infos);
    },
  },
};
</script>
